module.exports = __webpack_public_path__ + "img/mouth-03.9918ff97.svg";